// extracted by mini-css-extract-plugin
module.exports = {"UserSkills__list":"UserSkills_UserSkills__list__sY7k5","UserSkills__tag":"UserSkills_UserSkills__tag__2l0KB"};